var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconCart = function SvgIconCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 26,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.448 21V7.62h17.38V21a4 4 0 0 1-4 4h-9.38a4 4 0 0 1-4-4Z",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.414 10.103V4.724A3.724 3.724 0 0 1 10.138 1v0a3.724 3.724 0 0 1 3.724 3.724v5.38",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "square"
  })));
};
export default SvgIconCart;